import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { Phone } from 'lucide-react';
import { businessInfo } from '../../data/mock';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
      
      {/* Mobile Sticky Call Button */}
      <a 
        href={`tel:${businessInfo.phone}`}
        className="mobile-sticky-btn md:hidden"
        aria-label="Call us"
      >
        <Phone size={24} />
      </a>
    </div>
  );
};

export default Layout;